import { Funding, FundingState } from 'src/app/stores/tunnel/model/tunnel-data-state';

/**
 * Code sentinelle posé par `BaseAppService.buildEmptyFunding()` et par
 * `BaseAppService.mapOfferResultToLiteOfferResult(null)` quand aucune offre n'est exploitable.
 */
export const NO_OFFER_CODE = 'Aucune offre';

/**
 * Un scénario de financement est « vide » sous deux formes selon sa provenance :
 * - `offerTable: []` — `TunnelDataStore.buildEmptyFunding()`, via `disableCurrentFunding()` ;
 * - une unique ligne sentinelle « Aucune offre » — `BaseAppService.buildEmptyFunding()`, via les
 *   mappers de pricing quand l'API ne renvoie pas les offres persistées.
 *
 * Tester la seule longueur de `offerTable` rate la seconde forme (length === 1) : c'est ce qui
 * empêchait les gardes de recalcul de se déclencher à la réouverture d'un projet.
 */
export function isFundingEmpty(funding?: Funding): boolean {
  const offerTable = funding?.offerTable;
  if (!offerTable?.length) {
    return true;
  }

  return offerTable.every(offer => !offer || offer.code === NO_OFFER_CODE);
}

/**
 * Vrai si l'état de financement est absent, ou si l'un des deux scénarios (avec/sans pose) ne porte
 * aucune offre exploitable : le financement doit alors être recalculé auprès de l'API.
 */
export function isFundingStateEmpty(state?: FundingState): boolean {
  return (
    state === undefined ||
    isFundingEmpty(state.fundingWithInstallation) ||
    isFundingEmpty(state.fundingWithoutInstallation)
  );
}
